import { Commit } from 'vuex'

interface State {
  ready: boolean
  stripe: stripe.Stripe | unknown
}

const initialState: State = {
  ready: false,
  stripe: {},
}

export enum StripeActionTypes {
  LoadSdk = '[Stripe] LoadSdk',
}

export enum StripeMutationTypes {
  LoadSdkSuccess = '[Stripe] LoadSdkSuccess',
  SetStripe = '[Stripe] SetStripe',
}

export default {
  state: initialState,
  getters: {
    getStripeSdkLoaded(state: State): boolean {
      return state.ready
    },
    getStripe(state: State): stripe.Stripe | unknown {
      return state.stripe
    },
  },
  actions: {
    [StripeActionTypes.LoadSdk](
      { commit }: { commit: Commit },
      isYachtCharter: boolean,
    ) {
      const src = 'https://js.stripe.com/v3/'
      return new Promise((resolve: any, reject: any) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve()

          return
        }

        const el: HTMLScriptElement = document.createElement('script')

        el.type = 'text/javascript'
        el.async = true
        el.src = src

        el.addEventListener('load', resolve)
        el.addEventListener('error', reject)
        el.addEventListener('abort', reject)

        document.head.appendChild(el)
      }).then(() => {
        commit(StripeMutationTypes.LoadSdkSuccess)
        commit(StripeMutationTypes.SetStripe, isYachtCharter)
      })
    },
  },
  mutations: {
    [StripeMutationTypes.LoadSdkSuccess](currentState: State) {
      currentState.ready = true
    },
    [StripeMutationTypes.SetStripe](state: State, isYachtCharter: boolean) {
      state.stripe = isYachtCharter
        ? Stripe(`${process.env.VUE_APP_STRIPE_EUR_ACC_PK}`)
        : Stripe(`${process.env.VUE_APP_STRIPE_PK}`)
    },
  },
}
